import { useApi } from "@/api";
import { TAccount } from "@/api/v1_0";
import { RootStore } from "@/store/root";
import endOfMonth from "date-fns/endOfMonth";
import format from "date-fns/format";
import startOfMonth from "date-fns/startOfMonth";
import { makeAutoObservable } from "mobx";
import { ITotal, TTotalMap } from "./types";

export class OperationsStore {
  private _rootStore: RootStore;

  public loading = false;
  public refreshing = false;

  public date: Date = new Date();
  public accounts: TTotalMap = new Map<TAccount["uuid"], ITotal>();

  constructor(rootStore: RootStore) {
    this._rootStore = rootStore;

    makeAutoObservable(this);
  }

  public load = async (): Promise<void> => {
    this._rootStore.logging.track("operations.load", { date: this.date });

    try {
      this.loading = true;

      const api = useApi();

      const { data: result } =
        await api.v10.appHttpApiV10ControllerWalletSummaryTotalsRead({
          start: format(startOfMonth(this.date), "yyyy-MM-dd"),
          end: format(endOfMonth(this.date), "yyyy-MM-dd"),
        });

      this.accounts = result.reduce(
        (accounts, account) => accounts.set(account.uuid, account),
        new Map<TAccount["uuid"], ITotal>()
      );
    } catch (err) {
      throw this._rootStore.logging.capture(err);
    } finally {
      this.loading = false;
    }
  };

  public refresh = async (): Promise<void> => {
    try {
      this.refreshing = true;

      await this.load();
    } finally {
      this.refreshing = false;
    }
  };
}
